module.exports = __webpack_public_path__ + "static/media/oral-chart.772e5c6f.png";